"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Drawer = _interopRequireDefault(require("./Drawer.style"));

var _HoverAccentButton = _interopRequireDefault(require("../Button/HoverAccentButton"));

var Drawer = function Drawer(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      className = _ref.className,
      onCloseClick = _ref.onCloseClick,
      hideCloseButton = _ref.hideCloseButton,
      _ref$rootRef = _ref.rootRef,
      rootRef = _ref$rootRef === void 0 ? function () {} : _ref$rootRef;
  return _react.default.createElement("div", {
    ref: rootRef,
    className: (0, _classnames.default)(_Drawer.default.drawer(visible), className)
  }, !hideCloseButton && _react.default.createElement(_HoverAccentButton.default, {
    onClick: onCloseClick,
    icon: {
      type: 'close'
    },
    className: _Drawer.default.button()
  }), children);
};

Drawer.defaultProps = {
  hideCloseButton: false
};
Drawer.propTypes = {
  visible: _propTypes.default.bool.isRequired,
  onCloseClick: _propTypes.default.func.isRequired,
  hideCloseButton: _propTypes.default.bool
};
var _default = Drawer;
exports.default = _default;